import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import DSDialog from '../../design-system/DSDialog';
import DSDialogTitle from '../../design-system/DSDialogTitle';
import DSDialogContent from '../../design-system/DSDialogContent';
import DSIconButton from '../../design-system/DSIconButton';
import { DSTypography } from '../../design-system/Typography';

type TermsDialogProps = {
  open: boolean;
  onClose: () => void;
};

const TermsDialog = ({ open, onClose }: TermsDialogProps) => {
  return (
    <DSDialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: { xs: '100vw', md: '80vw' },
          height: { xs: '100vh', md: '80vh' },
          maxWidth: 'none',
          maxHeight: 'none',
          margin: { xs: 0, md: 'auto' },
        },
      }}
    >
      <DSDialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: 1,
        }}
      >
        Terms and Conditions
        <DSIconButton onClick={onClose} size="small">
          <CloseIcon />
        </DSIconButton>
      </DSDialogTitle>
      <DSDialogContent sx={{ padding: { xs: 2, md: 3 }, overflow: 'auto' }}>
        <DSTypography sx={{ fontFamily: 'Gilroy-Medium', lineHeight: 1.8 }}>
          By creating a KlydoGreet, you agree to Klydo's Terms of Service and
          Privacy Policy. The greeting content you provide will be displayed on
          the recipient's clock. You confirm you have the right to use any
          images or text submitted. Klydo reserves the right to reject
          inappropriate content.
        </DSTypography>
        <DSTypography sx={{ mt: 2, fontFamily: 'Gilroy-Medium' }}>
          For full terms, visit{' '}
          <a
            href="https://www.klydoclock.com/pages/terms-of-service"
            target="_blank"
            rel="noreferrer"
            style={{ color: 'inherit' }}
          >
            klydoclock.com/pages/terms-of-service
          </a>
        </DSTypography>
      </DSDialogContent>
    </DSDialog>
  );
};

export default TermsDialog;
